import { render, staticRenderFns } from "./searchTextInput.vue?vue&type=template&id=bb08bd96&scoped=true"
import script from "./searchTextInput.vue?vue&type=script&lang=js"
export * from "./searchTextInput.vue?vue&type=script&lang=js"
import style0 from "./searchTextInput.vue?vue&type=style&index=0&id=bb08bd96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb08bd96",
  null
  
)

export default component.exports